// Reads like the hero -- software, then AI -- and then where it runs: on the
// device, and against the systems a business already has. Shared with
// scripts/prerender-heads.js so the static HTML matches the page.
const services = [
    {
        title: 'Custom Software',
        description:
            'Web, desktop and mobile applications, designed around how your operation runs and supported after launch.',
    },
    {
        title: 'Applied AI',
        description:
            'AI built into the product: computer vision, generated reports, decision support.',
    },
    {
        title: 'Firmware & Devices',
        description:
            'Firmware, device apps, managed fleets and the cloud behind them.',
    },
    {
        title: 'Systems Integration',
        description:
            'New software that works with your ERP and back-office systems.',
    },
];

export default services;
